import React, { useContext, useEffect, useRef, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { powerbi } from 'powerbi-client';
import { instance } from '../../store/utils';
import { useDispatch, useSelector } from 'react-redux';
import includes from 'lodash/includes';
import { isBeneficiary } from 'utils';
import { checkUser, getTaxisData, getUser } from 'store/user/actions';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { isSupplier, isVoucherViewer, isVoucherAuditor } from 'utils';

const Reports = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reportRef = useRef(null);
  const user = useSelector(state => state.user);
  const groups = useSelector(state => state.user?.groups);
  const userType = isVoucherAuditor(groups) ? 'vouchers-auditor' : 'vouchers'; //groups && isKtP(groups) ? "ktp" : groups && isProvider(groups) ? "provider" : isMinistry(groups) ? "ktp" : "store";   //logika tha allaksei kai tha pairnei mono ktp h tipota (brb w8 for cr)
  const [url, setUrl] = useState('');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState('');
  const suppliersList = ["Overview", "Applications Evaluation"];
  const viewersList = ["Overview", "Applications Evaluation"];
  const voucherAuditorsList = ["Suppliers", "Products", "vouchers"];
  const [usersList, setUsersList] = useState([]);

  const [reportConfig, setReportConfig] = useState({
    type: 'report',
    embedUrl: undefined,
    accessToken: undefined,
    id: undefined,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      background: models.BackgroundType.Transparent,
      navContentPaneEnabled: false,
    },
  });

  const getPowerBiLink = async () => {
    return await instance
      .get(`/app/rest/reports/${userType}`)
      .then(response => {
        return response;
      });
  };

  const navigateToPage = async pageName => {
    setActivePage(pageName);

    const report = reportRef.current?._embed;
    if (report) {
      const pages = await report.getPages();
      const page = pages.find(p => p.displayName === pageName);
      if (page) {
        await page.setActive();
      }
    }
  };

  useEffect(() => {
    if (groups) {
      if (isSupplier(groups)) {
        setUsersList(suppliersList);
      } else if (isVoucherViewer(groups)) {
        setUsersList(viewersList);
      } else if (isVoucherAuditor(groups)) {
        setUsersList(voucherAuditorsList);
      } else {
        setUsersList([]);
      }
    }
  }, [groups]);
    
  useEffect(() => {
    if (groups) {
      getPowerBiLink().then(data => {
        const embedUrlWithLocale = `${data.data.embedReports.embedUrl}&language=en&formatLocale=en-US`;
        setToken(data.data.embedToken.token);
        setUrl(embedUrlWithLocale);
      });
    }
  }, [groups]);

  useEffect(() => {
    dispatch(checkUser(navigate));
    dispatch(getUser());
    dispatch(getTaxisData());
  }, [dispatch, navigate]);

  useEffect(() => {
    if (token !== '' && url !== '') {
      setReportConfig({
        ...reportConfig,
        embedUrl: url,
        accessToken: token,
        id: url
          .toString()
          .substring(
            url.toString().indexOf('=') + 1,
            url.toString().indexOf('&')
          ),
        filters: [],
      });
      setLoading(false);
    }
  }, [token, url]);

  const applyConditionalFilters = report => {
    report.getActivePage().then(page => {
      if (userType === 'vouchers' && isSupplier(groups)) {
        const filters = [
          {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: {
              table: 'voucher_business_view',
              column: 'supplier',
            },
            operator: 'In',
            values: [user?.tenantId],
          },
        ];
        report.setFilters(filters);
      } else {
        report.setFilters([]);
      }
    });
  };

  useEffect(() => {
    const report = reportRef.current?._embed;

    if (
      report &&
      reportConfig.embedUrl &&
      reportConfig.accessToken &&
      usersList.length > 0
    ) {
      report.on('loaded', async () => {
        await navigateToPage(usersList[0]);
        applyConditionalFilters(report);
      });
      report.on('pageChanged', () => {
        applyConditionalFilters(report);
      });
    }
  }, [reportConfig, user]);

  return loading ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100dvh',
        width: '100%',
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <div>
      <div className="custom-nav">
        {usersList.map(item => (
          <button
            className={
              usersList.length > 1 && activePage === item ? 'active' : ''
            }
            onClick={() => navigateToPage(item)}
            key={item}
          >
            {item === 'Applications Evaluation'? 'Applications'
            : item === 'vouchers'? 'Vouchers': item}
          </button>
        ))}
      </div>
      <div className="powerbi-report-style-class">
        <PowerBIEmbed
          ref={reportRef}
          cssClassName={'report-style-class'}
          embedConfig={reportConfig}
        />
      </div>
    </div>
  );
};

export default Reports;
